import api from './api';

export const uploadService = {
    uploadToFolder(file: File, folder: string) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('folder', folder);
        return api.post('/uploads', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
};
